var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documents.length)?_c('div',{class:'container-grid grid-md-1 grid-' + _vm.grid},_vm._l((_vm.documents),function(document,index){return _c('document',{key:index,attrs:{"title":document.title,"link":document.link}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }